import { makeAutoObservable, runInAction } from 'mobx'
import { ConfigApi } from 'entities/Config/api/config'
import { type IResponseConfig } from 'entities/Config/api/types'

export class ConfigStore {
  initPromise
  private setFinishInit: ((value?: unknown) => void) | null = null
  private _loading = true
  private _config: IResponseConfig | null = null

  constructor() {
    makeAutoObservable(this)
    this.initPromise = new Promise((resolve) => {
      this.setFinishInit = resolve
    })
  }

  private fetchConfig = async () => {
    try {
      runInAction(() => {
        this._loading = true
      })

      const { data } = await ConfigApi.getUsersConfig()

      runInAction(() => {
        this._config = data
      })
    } catch (e) {
      console.log(e)
    } finally {
      runInAction(() => {
        this._loading = false
      })
    }
  }

  init = async () => {
    await this.fetchConfig()
    this.setFinishInit?.()
  }

  setIntegrationDisconnected = (value: boolean) => {
    if (!this._config) return

    this._config.integrationDisconnected = value
  }

  get admin() {
    return this._config?.developer
  }

  get banner10DLC() {
    return this._config?.['10dlc_banners_info']
  }

  get intercom() {
    return this._config?.intercom
  }

  get showUKComplianceModal() {
    return this._config && !this._config.uk_compliance_info.modal_shown
  }

  get integrationDisconnected() {
    if (!this._config) return false

    return Boolean(this._config.integrationDisconnected)
  }

  get config() {
    return this._config
  }

  get loading() {
    return this._loading
  }
}
